/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './confirm/confirm.js';
import './csvVerificationProgress.tpl.html';
import './metadataConfirmView/metadataConfirmView.js';
import './metadataSelectView/metadataSelectView.js';
import './metadataSettings/metadataSettings.js';
import './modal/preview.js';
import './modal/saveModal.js';
import './restore.tpl.html';
import './selectDestinationView/selectDestinationView.js';
import './selectView/selectview.js';
import './settings/settings.js';
import './uploadView/uploadView.js';
import './verifiedCsvSelectView/verifiedcsvselectview.js';

angular
  .module('bulkRestore', [
    'ui.router',
    'ngAnimate',
    'bulkRestore.confirm',
    'bulkRestore.metadataConfirmView',
    'bulkRestore.metadataSelectView',
    'bulkRestore.metadataSettings',
    'bulkRestore.overwriteValues',
    'bulkRestore.preview',
    'bulkRestore.settings',
    'bulkRestore.selectview',
    'bulkRestore.selectDestinationView',
    'bulkRestore.specificFields',
    'bulkRestore.uploadView',
    'bulkRestore.verifiedCsvSelectView',
    'sbsf.constants',
    'services.bulkrestoredata',
    'services.error',
    'services.view',
    'shared.confirmModal'
  ])
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      // This view is shared between multiple states
      var csvVerificationProgress = {
        templateUrl: 'bulkRestore/csvVerificationProgress.tpl.html',
        controller: 'SharedProgressCtrl'
      };

      // These params are shared between multiple states
      var bulkRestoreParams = {
        // This will be set if we've already entered the flow
        bulkRestoreData: {
          value: null,
          squash: true
        },
        // This will be set if we're coming in from a link in an email
        page: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from a link in an email
        batchId: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log
        bulkRestoreType: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log
        batch: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log for a backup
        objectStates: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log for a backup
        objectType: {
          value: null,
          squash: true
        }
      };

      // This defines the main abstract bulk restore view that is shared across all subviews.
      $stateProvider
        .state(VIEW_STATES.BULK_RESTORE, {
          abstract: true,
          views: {
            content: {
              templateUrl: 'bulkRestore/restore.tpl.html',
              controller: 'BulkRestoreCtrl'
            }
          },
          resolve: {
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ]
          }
        })
        .state(VIEW_STATES.BULK_RESTORE_ENTER, {
          url: '/bulkRestore/enter',
          params: bulkRestoreParams
        })
        // The views that are rendered in the object select view.
        .state(VIEW_STATES.BULK_RESTORE_SELECT_OBJECT, {
          url: '/bulkRestore/selectview',
          params: bulkRestoreParams,
          resolve: {
            objectTypes: [
              'BulkRestoreService',
              function (BulkRestoreService) {
                return BulkRestoreService.getObjectTypes(true, {});
              }
            ]
          },
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/selectView/selectview.tpl.html',
              controller: 'BulkRestoreSelectViewCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the CSV upload view.
        .state(VIEW_STATES.BULK_RESTORE_UPLOAD_CSV, {
          url: '/bulkRestore/uploadView',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/uploadView/uploadView.tpl.html',
              controller: 'BulkRestoreUploadViewCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the metadata select view.
        .state(VIEW_STATES.BULK_RESTORE_SELECT_METADATA, {
          url: '/bulkRestore/metadataSelectView',
          params: bulkRestoreParams,
          resolve: {
            batchPicker: (BasicBatchPickerStore) => new BasicBatchPickerStore()
          },
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/metadataSelectView/metadataSelectView.tpl.html',
              controller: 'BulkRestoreMetadataSelectViewCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the select view after a CSV verification.
        .state(VIEW_STATES.BULK_RESTORE_SELECT_CSV, {
          url: '/bulkRestore/verifiedcsvselectview',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/verifiedCsvSelectView/verifiedcsvselectview.tpl.html',
              controller: 'BulkRestoreVerifiedCsvSelectViewCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the restore destination view.
        .state(VIEW_STATES.BULK_RESTORE_SELECT_DEST, {
          url: '/bulkRestore/selectDestinationView',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/selectDestinationView/selectDestinationView.tpl.html',
              controller: 'BulkRestoreSelectDestinationViewCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the settings view.
        .state(VIEW_STATES.BULK_RESTORE_SETTINGS, {
          url: '/bulkRestore/settings',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/settings/settings.tpl.html',
              controller: 'BulkRestoreSettingsCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the confirm view.
        .state(VIEW_STATES.BULK_RESTORE_CONFIRM_OBJECT, {
          url: '/bulkRestore/confirm',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/confirm/confirm.tpl.html',
              controller: 'RestoreConfirmCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        .state(VIEW_STATES.BULK_RESTORE_METADATA_SETTINGS, {
          url: '/bulkRestore/metadataSettings',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/metadataSettings/metadataSettings.tpl.html',
              controller: 'BulkRestoreMetadataSettingsCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the metadata restore confirmation view.
        .state(VIEW_STATES.BULK_RESTORE_CONFIRM_METADATA, {
          url: '/bulkRestore/metadataConfirmView',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkRestore/metadataConfirmView/metadataConfirmView.tpl.html',
              controller: 'BulkRestoreMetadataConfirmViewCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        });
    }
  ])
  /**
   * Controller for the bulk restore view.
   */
  .controller('BulkRestoreCtrl', [
    '$q',
    '$scope',
    '$state',
    '$rootScope',
    'WizardService',
    'BulkRestoreDataFactory',
    'BulkRestoreService',
    'BulkRestoreType',
    'ErrorService',
    'progressFactory',
    'httpBatch',
    'batchUtils',
    'viewUtils',
    'orgInfo',
    'VIEW_STATES',
    'BULK_RESTORE_TYPES',
    'BULK_RESTORE_DEST_TYPES',
    'ALERT_EVENTS',
    'SOBJECT_STATE',
    'configService',
    function (
      $q,
      $scope,
      $state,
      $rootScope,
      WizardService,
      BulkRestoreDataFactory,
      BulkRestoreService,
      BulkRestoreType,
      ErrorService,
      progressFactory,
      httpBatch,
      batchUtils,
      viewUtils,
      orgInfo,
      VIEW_STATES,
      BULK_RESTORE_TYPES,
      BULK_RESTORE_DEST_TYPES,
      ALERT_EVENTS,
      SOBJECT_STATE,
      configService
    ) {
      // Publish some functions for testing
      $scope.initBulkRestoreDataForVerifiedCsv = initBulkRestoreDataForVerifiedCsv;

      initBulkRestoreData()
        .then(function (bulkRestoreData) {
          $scope.bulkRestoreData = bulkRestoreData;

          watchForDestroy();
          watchCsvVerification();
          goToInitialState();
        })
        .finally(function () {
          // initBulkRestoreData may have shown the loading mask if it needed to load a batch
          $rootScope.showLoadingMask = false;
        });

      /**
       * Initializes the bulk restore data if it was not passed in.
       *
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initBulkRestoreData() {
        var bulkRestoreData = $state.params.bulkRestoreData;
        var promise;

        if (bulkRestoreData) {
          promise = $q.when(bulkRestoreData);
        } else {
          // The page param will be set if we're getting here from a link in an email.
          // The bulkRestoreType will be set if we're getting here from the activity log.
          if (
            $state.params.page === 'bulkRestoreCsv' ||
            $state.params.bulkRestoreType === BulkRestoreType.VERIFIED_CSV
          ) {
            // We have to load the batch in order to initialize the bulk restore data
            promise = initBulkRestoreDataForVerifiedCsv($state.params);
          } else if ($state.params.bulkRestoreType === BulkRestoreType.BACKUP) {
            promise = initBulkRestoreDataForBackup($state.params);
          } else {
            // Create the default data
            bulkRestoreData = BulkRestoreDataFactory.generate(BulkRestoreType.MANUAL, { sourceOrgInfo: orgInfo });
            promise = $q.when(bulkRestoreData);
          }
        }

        return promise;
      }

      /**
       * Initializes the bulk restore data for a verified CSV.
       *
       * @param {{[batchId]: number, [batch]: object}} params - the CSV verification params.
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initBulkRestoreDataForVerifiedCsv(params) {
        // See if the batch is already present
        var promise;
        if (params.batch) {
          promise = $q.when(params.batch);
        } else if (params.batchId) {
          $rootScope.showLoadingMask = true;
          promise = batchUtils.loadBatch(params.batchId);
        } else {
          throw new Error('batch or batchId is required');
        }

        return promise.then(function (batch) {
          var csvData = batch.bulkRestoreCsvVerificationData;
          var destType =
            csvData.sourceOrgId === csvData.targetOrgId
              ? BULK_RESTORE_DEST_TYPES.SAME_ORG
              : BULK_RESTORE_DEST_TYPES.CROSS_ORG;
          var destOrgInfo = {
            id: csvData.targetOrgId,
            name: csvData.targetOrgName,
            accessTokenOwnerId: csvData.accessTokenOwnerId
          };
          var isFailure = batch.status === 'FAILURE';
          var csvFailureMsg;

          // If it's a failure we need the events
          if (isFailure && !batch.events) {
            promise = batchUtils.getBatchEvents(batch.batchId);
          } else {
            promise = $q.when(batch.events);
          }

          return promise
            .then(function (events) {
              csvFailureMsg = isFailure ? events[0].message : '';

              // If the object type is not specified that means there's more than one type and we have to get the types
              // from the server.
              if (csvData.sobjectType) {
                promise = $q.when([csvData.sobjectType]);
              } else {
                promise = BulkRestoreService.getCsvObjectTypes(batch.batchId);
              }

              return promise;
            })
            .then(function (csvObjectTypes) {
              var bulkRestoreData = BulkRestoreDataFactory.generate(BulkRestoreType.VERIFIED_CSV, {
                backupBatchDate: csvData.batchIdToVerifyDate,
                backupBatchId: csvData.batchIdToVerify,
                csvBatchId: batch.batchId,
                csvCompletedBulkRestoreBatch: _.first(csvData.completedBulkRestoreBatches),
                csvDuplicateCount: batch.duplicateObjects,
                csvFailed: isFailure,
                csvFailureMsg: csvFailureMsg,
                csvFileName: csvData.fileName,
                csvInvalidCount: batch.invalidObjects,
                csvObjectTypes: csvObjectTypes,
                destOrgInfo: destOrgInfo,
                destType: destType,
                searchObjectStates: [SOBJECT_STATE.UPDATED],
                sourceOrgInfo: orgInfo
              });

              // Start with all records selected for a verified CSV restore
              bulkRestoreData.setSelectingAll(true);

              return bulkRestoreData;
            });
        });
      }

      /**
       * Initializes the bulk restore data for restoring from a backup.
       *
       * @param {{batch: object, objectStates: number[], objectType: string}} params - the backup params.
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initBulkRestoreDataForBackup(params) {
        if (!params.batch) {
          throw new Error('batch is required');
        }

        if (!params.objectStates) {
          throw new Error('objectStates is required');
        }

        if (!params.objectType) {
          throw new Error('objectType is required');
        }

        var bulkRestoreData = BulkRestoreDataFactory.generate(BulkRestoreType.BACKUP, {
          backupBatchId: params.batch.batchId,
          backupBatchDate: params.batch.date,
          searchObjectStates: params.objectStates,
          searchObjectType: params.objectType,
          sourceOrgInfo: orgInfo
        });

        // Start with all records selected for a restore from backup
        bulkRestoreData.setSelectingAll(true);

        return $q.when(bulkRestoreData);
      }

      /**
       * Watches for the scope to be destroyed in order to do some clean-up.
       */
      function watchForDestroy() {
        $scope.$on('$destroy', function () {
          viewUtils.resetKey('restore');
          $rootScope.$emit(ALERT_EVENTS.CLOSE.eventName);
        });
      }

      /**
       * Watches for progress on a CSV verification and updates the restore flow when it completes.
       */
      function watchCsvVerification() {
        // When the user initiates a CSV verification we'll give them the option to stay on this page and wait or go to
        // the dashboard. If there is already a CSV verification running we'll show this mask from the start.
        $rootScope.showMaskWithDashboardButton = progressFactory.bulkRestoreCsvVerificationInProgress;

        // When we start a CSV verification we show a mask on the screen. Watch for the verification to finish so we can
        // remove the mask.
        $scope.$watch(
          function () {
            return progressFactory.bulkRestoreCsvVerificationInProgress;
          },
          function (newValue, oldValue) {
            if (oldValue === true && newValue === false) {
              httpBatch
                .getLatestBulkRestoreCsvVerification()
                .then(function (batch) {
                  return $scope.initBulkRestoreDataForVerifiedCsv({ batch: batch });
                })
                .then(function (bulkRestoreData) {
                  // Get the wizard set up for the new state
                  initWizard(VIEW_STATES.BULK_RESTORE_SELECT_CSV);
                  $state.go(VIEW_STATES.BULK_RESTORE_SELECT_CSV, { bulkRestoreData: bulkRestoreData });
                })
                .catch(function (err) {
                  ErrorService.report(err);
                })
                .finally(function () {
                  $rootScope.showLoadingMask = false;
                  $rootScope.showMaskWithDashboardButton = false;
                });
            } else if (oldValue === false && newValue === true) {
              // Show the dashboard mask when a verification starts
              $rootScope.showMaskWithDashboardButton = true;
            }
          }
        );
      }

      /**
       * Determines the initial state of the wizard from the data source.
       */
      function goToInitialState() {
        var state = VIEW_STATES.BULK_RESTORE_SELECT_DEST;

        switch ($scope.bulkRestoreData.getRestoreType()) {
          case BulkRestoreType.BACKUP:
            state = VIEW_STATES.BULK_RESTORE_SELECT_OBJECT;
            break;

          case BulkRestoreType.METADATA_COMPARE:
            state = VIEW_STATES.BULK_RESTORE_SELECT_METADATA;
            break;

          case BulkRestoreType.VERIFIED_CSV:
            state = VIEW_STATES.BULK_RESTORE_SELECT_CSV;
            break;

          case BulkRestoreType.MANUAL:
          default:
            break;
        }

        initWizard(state);
        $state.go(state, { bulkRestoreData: $scope.bulkRestoreData });
      }

      /**
       * Sets up the wizard service to track the flow through this wizard.
       *
       * @param {string} [initialState] - The start in which to start the wizard.
       */
      function initWizard(initialState) {
        var stepKeys;

        // Reset the WizardService so we start fresh each time
        WizardService.reset();

        // Determine the initial state if it's not supplied
        if (!initialState) {
          if (
            $state.current.name === VIEW_STATES.BULK_RESTORE_SELECT_OBJECT ||
            $state.current.name === VIEW_STATES.BULK_RESTORE_SELECT_CSV ||
            $state.current.name === VIEW_STATES.BULK_RESTORE_SELECT_METADATA
          ) {
            initialState = $state.current.name;
          } else {
            initialState = VIEW_STATES.BULK_RESTORE_SELECT_DEST;
          }
        }

        // The potential steps depend on the initial state
        switch (initialState) {
          case VIEW_STATES.BULK_RESTORE_SELECT_DEST:
            // Type has not been selected
            // null in the last position means we don't yet know the remaining steps
            stepKeys = ['SELECT_TYPE', null];
            break;

          case VIEW_STATES.BULK_RESTORE_SELECT_CSV:
          case VIEW_STATES.BULK_RESTORE_SELECT_OBJECT:
            // We started from a specific record type in a backup or from a verified CSV
            stepKeys = ['SELECT_ITEMS', 'RESTORE_SETTINGS', 'CONFIRM_RESTORE'];
            break;

          case VIEW_STATES.BULK_RESTORE_SELECT_METADATA:
            // We started from a specific record type in a backup
            stepKeys = ['SELECT_METADATA', 'RESTORE_SETTINGS', 'CONFIRM_RESTORE'];
            break;

          default:
            break;
        }

        // Initialize the wizard
        WizardService.setStatePrefix(VIEW_STATES.BULK_RESTORE + '.');
        WizardService.setNextState(getNextState);
        WizardService.setInitialState(initialState);
        WizardService.setStepKeys(stepKeys);
        WizardService.setCancelConfirmTextKey('CONFIRM_RESTORE_EXIT');
      }

      /**
       * Determines the state that comes after the current state, based on the current settings.
       *
       * @returns {string} the name of the state corresponding to the next page.
       */
      function getNextState() {
        var currentState = WizardService.getCurrentState();
        var nextState;

        switch (currentState) {
          case VIEW_STATES.BULK_RESTORE_SELECT_DEST:
            if ($scope.bulkRestoreData.isObjectRestore()) {
              if ($scope.bulkRestoreData.isManualObjectUpload()) {
                nextState = VIEW_STATES.BULK_RESTORE_UPLOAD_CSV;
              } else {
                nextState = VIEW_STATES.BULK_RESTORE_SELECT_OBJECT;
              }
            } else {
              // recordType === Metadata
              nextState = VIEW_STATES.BULK_RESTORE_SELECT_METADATA;
            }
            break;

          case VIEW_STATES.BULK_RESTORE_SELECT_OBJECT:
          case VIEW_STATES.BULK_RESTORE_SELECT_CSV:
            nextState = VIEW_STATES.BULK_RESTORE_SETTINGS;
            break;

          case VIEW_STATES.BULK_RESTORE_SELECT_METADATA:
            nextState = VIEW_STATES.BULK_RESTORE_METADATA_SETTINGS;
            break;

          case VIEW_STATES.BULK_RESTORE_SETTINGS:
            nextState = VIEW_STATES.BULK_RESTORE_CONFIRM_OBJECT;
            break;

          case VIEW_STATES.BULK_RESTORE_METADATA_SETTINGS:
            nextState = VIEW_STATES.BULK_RESTORE_CONFIRM_METADATA;
            break;

          default:
            break;
        }

        return nextState;
      }

      configService.getConfig().then((config) => {
        $rootScope.config = config;
      });
    }
  ]);
